import type { GetStaticProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { career } from "../routes/namespaces";
import CareerPage from "../Career/CareerPage";
import { QueryClient, dehydrate } from "@tanstack/react-query";
import { fetchJobOffers } from "../data/jobOffers/jobOffers";

const Career: NextPage = () => {
  return <CareerPage />;
};

export default Career;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  if (locale) {
    await queryClient.prefetchQuery(
      ["job-offers", { locale: locale }],
      fetchJobOffers
    );
  }

  return {
    revalidate: 3600,
    props: {
      ...(await serverSideTranslations(
        locale || "cs",
        career
      )),
      dehydratedState: dehydrate(queryClient),
    },
  };
};
